// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";

function OrderFareDetails$OrderFareItem(Props) {
  var label = Props.label;
  var value = Props.value;
  return React.createElement("div", {
              className: "adjust-fare-details-item"
            }, React.createElement("p", undefined, label), React.createElement("p", undefined, value));
}

var OrderFareItem = {
  make: OrderFareDetails$OrderFareItem
};

function OrderFareDetails(Props) {
  var crn = Props.crn;
  var currency_symbol = Props.currency_symbol;
  var fare_info = Props.fare_info;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var getAmountWithSymbol = function (amount) {
    return currency_symbol + " " + Currency.fromCurrency(amount).toFixed(2);
  };
  var getTimeWithSymbol = function (time) {
    return time.toFixed(2) + " MINS";
  };
  var getDistanceWithSymbol = function (distance) {
    return distance.toFixed(3) + " KMS";
  };
  var calculateTotalIncidentalCharges = function (charges) {
    return Belt_List.reduce(charges, Currency.fromString("0.0"), (function (acc, item) {
                  return Currency.add(acc, item.amount);
                }));
  };
  var waypoint_charge = fare_info.waypoint_charge;
  return React.createElement("div", {
              className: "c-adjust-fare-detail"
            }, React.createElement("h2", {
                  className: "adjust-fare-details-header"
                }, "Fare Details"), React.createElement("div", {
                  className: "adjust-fare-details-body"
                }, React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Base Fare",
                      value: getAmountWithSymbol(fare_info.base_fare)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Demand Surge Charge",
                      value: getAmountWithSymbol(fare_info.flat_surge)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Waiting time",
                      value: getTimeWithSymbol(fare_info.waiting_time)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Waiting Charges",
                      value: getAmountWithSymbol(fare_info.waiting_charge)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Travel Distance",
                      value: getDistanceWithSymbol(fare_info.travel_distance)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Distance Charge",
                      value: getAmountWithSymbol(fare_info.distance_charge)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Travel Duration",
                      value: getTimeWithSymbol(fare_info.travel_duration)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Duration Charge",
                      value: getAmountWithSymbol(fare_info.travel_duration_charge)
                    }), waypoint_charge !== undefined ? React.createElement(OrderFareDetails$OrderFareItem, {
                        label: "Waypoint Charge",
                        value: getAmountWithSymbol(Caml_option.valFromOption(waypoint_charge))
                      }) : null, React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Toll Charges",
                      value: getAmountWithSymbol(fare_info.toll)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Restricted Time",
                      value: getTimeWithSymbol(fare_info.total_restricted_time_mins)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Total Incidental Charge",
                      value: getAmountWithSymbol(calculateTotalIncidentalCharges(fare_info.incidental_charges))
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Road Tax",
                      value: getAmountWithSymbol(fare_info.road_tax)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "UP Entry charge",
                      value: getAmountWithSymbol(fare_info.convenience_charge)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "VAT",
                      value: getAmountWithSymbol(fare_info.vat)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Coupon Discount",
                      value: getAmountWithSymbol(fare_info.coupon_discount)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Porter Gold Savings",
                      value: getAmountWithSymbol(fare_info.subscription_discount)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Fare",
                      value: getAmountWithSymbol(fare_info.fare)
                    }), React.createElement(OrderFareDetails$OrderFareItem, {
                      label: "Cashback",
                      value: getAmountWithSymbol(fare_info.cash_back)
                    }), React.createElement("div", undefined, React.createElement("p", undefined, null), React.createElement("div", {
                          className: "adjust-fare-view-more-fare-details-container"
                        }, React.createElement(PrimaryButton$Catalyst.make, {
                              buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                    TAG: /* Custom */1,
                                    _0: (function (param) {
                                        return React.createElement("p", {
                                                    className: "adjust-fare-view-more-fare-details-button"
                                                  }, "View more fare detail");
                                      })
                                  }, false, (function (_event) {
                                      return Curry._2(workspaceDispatch.addTab, {
                                                  TAG: /* OrderFare */11,
                                                  order_crn: crn
                                                }, false);
                                    }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                            })))));
}

var make = OrderFareDetails;

export {
  OrderFareItem ,
  make ,
  
}
/* react Not a pure module */
